import styled from '@emotion/styled';

export const SentimentAnalysisBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 2px 4px 2px 2px;
  gap: 4px;
  width: fit-content;
  cursor: default;

  .sentiment-icon {
    display: inline-flex;

    &--big {
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
